import React, { useState } from "react";
import "./management.css";

function Management(props) {
  const [comndStatus, setComandStatus] = useState(null);
  const cmdlist = {
    on: "on",
    off: "off",
  };

  const handleCommand = (comand, callBack) => {
    const record = {
      topic: props.activeVehicle,
      qos: 0,
    };
    record.command = comand;
    props.sendCommand(record);
    callBack();
  };

  return (
    <div className="management">
      <h1>Vehicle Management</h1>
      <h2>Remote Engine Cutoff</h2>
      <div className="modules">
        <div className="value">
          <div className="status">
            <h4>Engine Lock:</h4>
            <div className={`value2 ${props.status}`}>{props.status}</div>
          </div>
          <h3 className="cmdstatus">{comndStatus}</h3>
        </div>
        <div className="commands">
          <button
            onClick={() => {
              handleCommand(cmdlist.off, function () {
                setComandStatus("LOCK COMMAND SENT");
              });
            }}
          >
            Disable Engine
          </button>
          <button
            onClick={() => {
              handleCommand(cmdlist.on, function () {
                setComandStatus("UNLOCK COMMAND SENT");
              });
            }}
          >
            Enable Engine
          </button>
        </div>
      </div>
      <h2>Remote Voice Recording</h2>
      <div className="modules">
        <div className="value">
          <div className="status">
            <h4>Voice Recording :</h4>
            <div className={`value2`}>{`value`}</div>
          </div>
          <h3 className="cmdstatus">COMMAND STATUS</h3>
        </div>
        <div className="commands">
          <button>Start Recording</button>
          <button>Stop Recording</button>
        </div>
      </div>
      <h2>Activate Video Recording</h2>
      <div className="modules">
        <div className="value">
          <div className="status">
            <h4>Video Recording :</h4>
            <div className={`value2`}>{`value`}</div>
          </div>
          <h3 className="cmdstatus">COMMAND STATUS</h3>
        </div>
        <div className="commands">
          <button>Start Recording</button>
          <button>Stop Recording</button>
        </div>
      </div>
    </div>
  );
}

export default Management;
